/* global errorPanel */

import React from 'react'
import { addCsrfHeader, api } from 'components/api'
import { updateImagePath } from 'components/routes/api'
import Form from './Form'
import PropTypes from 'prop-types'

class Uploader extends React.Component {
  constructor (props) {
    super(props)

    this.fileInputRef = React.createRef()

    this.state = {
      imageUrl: '',
      imageId: null
    }
  }

  componentDidMount () {
    this.setState({
      imageUrl: this.props.imageUrl,
      imageId: this.props.imageId
    })
  }

  hasImage = () => {
    return !!this.state.imageId
  }

  invokeCallback = (imageId) => window[this.props.setImageCallback](imageId)

  handleRemove = (event) => {
    event.preventDefault()
    const baseHeaders = { 'Content-Type': 'application/json' }
    const request = {
      url: updateImagePath(this.state.imageId),
      headers: addCsrfHeader(baseHeaders, document)
    }

    api.delete(request)
      .then(() => {
        this.setState({
          imageId: null,
          imageUrl: ''
        })
        this.invokeCallback(null)
      })
      .catch(() => {
        errorPanel(
          'Image could not be deleted. Please try again or contact support@procurated.com'
        )
      })
  }

  handleChange = (event) => {
    event.preventDefault()

    this.fileInputRef.current.click()
  }

  updateImage = (imageId, imageUrl) => {
    this.setState({
      imageId,
      imageUrl
    })
    this.invokeCallback(imageId)
  }

  renderUploader = () => (
    <>
      <div className='grid-x' data-testid='image-uploader'>
        <div className='small-12 cell'>
          <img
            alt='image placeholder'
            src={this.props.placeholderImage}
            style={{ width: '100%' }}
            onClick={(e) => this.handleChange(e)}
            className='image-placeholder'
          />
        </div>
      </div>
      <div className='grid-x'>
        <div className='small-12 medium-auto cell'>
          <button onClick={(e) => this.handleChange(e)}>Upload Image</button>
        </div>
        <div className='small-12 medium-shrink cell'>
          {this.props.requirements}
        </div>
      </div>
    </>
  )

  renderLoaded = () => (
    <>
      <div className='grid-x'>
        <div className='small-12 cell'>
          <img alt='article image' src={this.state.imageUrl} />
        </div>
      </div>

      <div className='grid-x grid-margin-x controls'>
        <div className='small-12 medium-shrink cell'>
          <button onClick={(e) => this.handleRemove(e)}>Remove Image</button>
        </div>
        <div className='small-12 medium-shrink cell'>
          <button onClick={(e) => this.handleChange(e)}>Change Image</button>
        </div>
      </div>
    </>
  )

  renderInitial = () =>
    this.hasImage() ? this.renderLoaded() : this.renderUploader()

  handleCancelUpload = (event) => {
    event.preventDefault()
    this.setState({
      imageUrl: '',
      imageId: null
    })
  }

  render () {
    return (
      <div className='react-image-uploader'>
        <div>
          <Form
            updateImage={this.updateImage}
            imageId={this.state.imageId}
            handleCancelUpload={(e) => this.handleCancelUpload(e)}
            imageUrl={this.state.imageUrl}
            cropX={this.props.cropX}
            cropY={this.props.cropY}
            fileInputRef={this.fileInputRef}
          />
        </div>
        <div>{this.renderInitial()}</div>
      </div>
    )
  }
}

Uploader.propTypes = {
  cropX: PropTypes.number,
  cropY: PropTypes.number,
  imageId: PropTypes.number,
  imageUrl: PropTypes.string,
  placeholderImage: PropTypes.string,
  requirements: PropTypes.string,
  setImageCallback: PropTypes.string,
  title: PropTypes.string
}

export default Uploader
